import React from "react";
import { Reveal } from "@/components/effects/Reveal";
import { LightStreaks } from "@/components/effects/LightStreaks";

const IMG_PRIMARY =
  "https://images.unsplash.com/photo-1532712938310-34cb3982ef74?w=1400&q=85&auto=format&fit=crop";
const IMG_SECONDARY =
  "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=1200&q=85&auto=format&fit=crop";
const IMG_TERTIARY =
  "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=1200&q=85&auto=format&fit=crop";

export const EventPhotography = () => {
  return (
    <section data-testid="event-photography-section" className="relative py-28 sm:py-36 overflow-hidden">
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(60% 50% at 80% 30%, rgba(255,46,147,0.10) 0%, transparent 65%)," +
            "radial-gradient(60% 50% at 10% 80%, rgba(24,211,255,0.10) 0%, transparent 65%)," +
            "linear-gradient(180deg, #050507, #000)",
        }}
      />
      <LightStreaks count={3} />

      <div className="max-w-[1280px] mx-auto px-6 sm:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <Reveal>
            <p className="text-[11px] tracking-luxe uppercase text-white/45 mb-4">
              — Event Photography
            </p>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05]">
              <span className="text-chrome">From the roar of the crowd</span>{" "}
              <span className="italic text-magcyan">to the quiet candlelight</span>
              <span className="text-chrome">.</span>
            </h2>
          </Reveal>
          <Reveal delay={240}>
            <p className="mt-8 text-white/65 leading-relaxed font-body max-w-xl">
              From action-packed sports moments to elegant celebrations, WelkomBiz
              Photography captures the emotion, energy and detail of every event
              with premium quality and professional care.
            </p>
          </Reveal>

          <Reveal delay={360}>
            <ul className="mt-10 grid grid-cols-2 gap-y-4 gap-x-6 text-sm font-body">
              {[
                "Multi-photographer coverage",
                "Cinematic editing signature",
                "Same-week preview gallery",
                "Discreet on-site presence",
                "High-res print-ready originals",
                "Curated highlight selects",
              ].map((b) => (
                <li key={b} className="flex items-start gap-3 text-white/65">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-gradient-to-r from-[#ff2e93] to-[#18d3ff]" />
                  {b}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2 relative">
          <Reveal>
            <div className="photo-frame chrome-border w-full h-[260px] sm:h-[420px] lg:h-[560px] mx-auto">
              <img src={IMG_PRIMARY} alt="Event photography" className="w-full h-full object-cover" loading="lazy" />
            </div>
          </Reveal>

          <Reveal delay={220}>
            <div className="photo-frame chrome-border absolute -bottom-8 -left-4 sm:-left-10 w-[45%] sm:w-[48%] h-[110px] sm:h-[170px] lg:h-[200px] shadow-2xl hidden sm:block">
              <img src={IMG_SECONDARY} alt="Corporate event" className="w-full h-full object-cover" loading="lazy" />
            </div>
          </Reveal>

          <Reveal delay={380}>
            <div className="photo-frame chrome-border absolute -top-8 -right-4 sm:-right-10 w-[34%] h-[120px] lg:h-[170px] shadow-2xl hidden lg:block">
              <img src={IMG_TERTIARY} alt="Matric farewell" className="w-full h-full object-cover" loading="lazy" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default EventPhotography;
